import transform from 'sdp-transform';
import { NAME } from 'trtc-js-sdk-core';
import { isUndefined } from 'trtc-js-sdk-core/src/utils';

export const parse = function (sdp: string) {
  return transform.parse(sdp);
};

export const write = function (parsed: ReturnType<typeof transform.parse>) {
  return transform.write(parsed);
};

/**
 * 给 sdp 添加立体声描述
 * sprop-stereo=1 上行立体声
 * stereo=1 下行立体声
 * @param {String} sdp
 * @return {String} sdp
 */
export const addStereoDescription = function (sdp: string) {
  const parsedSDP = parse(sdp);
  parsedSDP.media.forEach(item => {
    if (item.type === NAME.AUDIO) {
      item.fmtp.forEach(fmtpItem => {
        fmtpItem.config += ';sprop-stereo=1;stereo=1';
      });
    }
  });
  return write(parsedSDP);
};

/**
 * 移除 sdp 中的 h264 描述
 * @export
 * @param {String} sdp
 * @return {String} sdp
 */
export function removeH264(sdp: string) {
  const parsedSDP = parse(sdp);
  parsedSDP.media.forEach(item => {
    if (item.type === NAME.VIDEO) {
      // 需要移除的 payloads
      const payloads = new Set();
      // h264 的 payload 需要移除
      item.rtp.forEach(({ payload, codec }) => codec === 'H264' && payloads.add(payload));
      // apt 为 h264 payload 的也需要移除
      item.fmtp.forEach(({ payload, config }) => {
        const matchApt = config.match(/apt=(\d+)/);
        if (matchApt && matchApt[1] && payloads.has(Number(matchApt[1]))) {
          payloads.add(payload);
        }
      });
      const filterFn = ({ payload } : { payload: number }) => !payloads.has(payload);
      item.rtp = item.rtp.filter(filterFn);
      item.rtcpFb = item.rtcpFb?.filter(filterFn);
      item.fmtp = item.fmtp.filter(filterFn);
      item.payloads = item.payloads
        ?.split(' ')
        .filter(payload => !payloads.has(Number(payload)))
        .join(' ');
    }
  });
  return write(parsedSDP);
}

/**
 * enableDtx 给sdp 增加或者删除 dtx 描述
 * @export
 * @param {String} sdp
 * @param {boolean|undefined} enableDtx
 * @return {String} sdp
 */
export const enableDtx = function (sdp: string, enableDtx: boolean|undefined) {
  if (isUndefined(enableDtx)) {
    return sdp;
  }
  const parsedSDP = parse(sdp);
  parsedSDP.media.forEach(item => {
    if (item.type === NAME.AUDIO) {
      item.fmtp.forEach(fmtpItem => {
        if (enableDtx) {
          fmtpItem.config += ';usedtx=1';
        } else {
          fmtpItem.config = fmtpItem.config
            .replace(/;?usedtx=\d/g, '')
            .replace(/^;/, '');
        }
      });
    }
  });
  return write(parsedSDP);
};

